import React, { useState, useEffect } from "react";
import styles from "./ERPTable.module.css";
import Pagination from "./Pagination";
import {
  getAllFixedAssetsErpData,
  fixedAssetListing,
} from "../../../Bookclosure/Services/ApiHandler";

const ERPDataTable = ({ FixedAssetID }) => {
  const headers = [
    "Asset ID",
    "Dep Rate",
    "Business Area",
    "Block of Asset",
    "Capitalized On",
    "Deactivated On",
    "Book Value of Deletion",
    "Opening Gross Block",
    "Opening Accumulated Depreciation",
    "Terminal Value of Asset",
    "Opening Book Value",
    "Acquisition Cost for Current Year Additions",
    "Depreciation Charge for the Period",
    "Deletion Gross Block",
    "Deletion Depreciation",
  ];

  const [allData, setAllData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [currentData, setCurrentData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (!FixedAssetID) return;
      try {
        const res = await getAllFixedAssetsErpData(FixedAssetID);
        const erpList =
          res.data?.ERPFixedAssetList ||
          res.data?.data ||
          (Array.isArray(res.data) ? res.data : []);

        if (erpList && erpList.length > 0) {
          const records = erpList.flatMap((pkg) => {
            if (Array.isArray(pkg.data) && pkg.data.length > 0) {
              return pkg.data;
            }
            if (pkg.assetId || pkg.name || pkg.company) {
              return [pkg];
            }
            return [];
          });

          if (records.length > 0) {
            setAllData(records);
            return;
          }
        }

        const listingRes = await fixedAssetListing(FixedAssetID, {
          page: 1,
          pageSize: 1000,
          filters: [],
        });
        if (listingRes.data?.fixedAssetListing?.length > 0) {
          setAllData(listingRes.data.fixedAssetListing);
        }
      } catch (err) {
        console.error("Failed to fetch ERP fixed assets table data:", err);
      }
    };
    fetchData();
  }, [FixedAssetID]);

  const totalPages = Math.ceil(allData.length / rowsPerPage) || 1;

  useEffect(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    setCurrentData(allData.slice(startIndex, endIndex));
  }, [allData, currentPage, rowsPerPage]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.tableContainer}>
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th key={index} className={styles.tableHeader}>
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td
                    colSpan={headers.length}
                    style={{ textAlign: "center", padding: "32px", color: "#777" }}
                  >
                    No ERP records found.
                  </td>
                </tr>
              ) : (
                currentData.map((row, index) => (
                  <tr key={index} className={styles.tableRow}>
                    <td className={styles.tableCell}>{row.assetId || row.name || "-"}</td>
                    <td className={styles.tableCell}>{row.depRate || "-"}</td>
                    <td className={styles.tableCell}>{row.businessArea || "-"}</td>
                    <td className={styles.tableCell}>{row.blockOfAsset || "-"}</td>
                    <td className={styles.tableCell}>{row.capitalizedOn || "-"}</td>
                    <td className={styles.tableCell}>{row.deactivatedOn || "-"}</td>
                    <td className={styles.tableCell}>{row.bookValueDeletion || "-"}</td>
                    <td className={styles.tableCell}>{row.openingGrossBlock || "-"}</td>
                    <td className={styles.tableCell}>
                      {row.openingAccDepreciation || "-"}
                    </td>
                    <td className={styles.tableCell}>{row.terminalValue || "-"}</td>
                    <td className={styles.tableCell}>{row.openingBookValue || "-"}</td>
                    <td className={styles.tableCell}>{row.acquisitionCost || "-"}</td>
                    <td className={styles.tableCell}>{row.depreciationCharge || "-"}</td>
                    <td className={styles.tableCell}>{row.deletionGrossBlock || "-"}</td>
                    <td className={styles.tableCell}>
                      {row.deletionDepreciation || "-"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className={styles.paginationWrapper}>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={setCurrentPage}
          onRowsPerPageChange={(rows) => {
            setRowsPerPage(rows);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>
  );
};

export default ERPDataTable;
